import { Components, Theme } from '@mui/material/styles'

export const tableCellTheme: Components<Theme>['MuiTableCell'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderColor: `${theme.palette.divider} !important`,
      fontSize: '1.2rem',
      '&:not(:last-child)': {
        borderRight: `1px solid`,
      },
      '& svg': {
        fontSize: '2rem',
        color: theme.palette.primary.main,
      },
    }),
    head: {
      fontWeight: 'bold',
    },
  },
}

export const tableRowTheme: Components<Theme>['MuiTableRow'] = {
  styleOverrides: {
    hover: ({ theme }) => ({
      '&:hover': {
        backgroundColor: theme.palette.header,
      },
    }),
  },
}

export const tableHeadTheme: Components<Theme>['MuiTableHead'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.header,
    }),
  },
}
